import { useMemo } from "react"
import { getCountriesList } from "../countryStateData.js"
import { COUNTRIES_CANADA_US } from "../utils/countries.js"

/**
 * Country list from bundled assets.
 * Returns raw rows (`id` + `name`) and a UI-friendly ordered name list.
 */
export function useCountries() {
    const countries = useMemo(() => getCountriesList(), [])

    const countryNames = useMemo(() => {
        const names = countries.map((c) => String(c?.name ?? "")).filter(Boolean)
        const unique = Array.from(new Set(names))
        unique.sort((a, b) => a.localeCompare(b))
        const pinned = COUNTRIES_CANADA_US.filter((x) => unique.includes(x))
        const rest = unique.filter((x) => !pinned.includes(x))
        return [...pinned, ...rest]
    }, [countries])

    return { countries, countryNames }
}
